module.exports = __webpack_public_path__ + "static/img/2-4.1a3085d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2-4.png
// module id = qxdg
// module chunks = 1